module.exports = __webpack_public_path__ + "static/devicesOTTcompos-1c2f9f7c6d630ce9945a731cda78d16e.png";